import { render, staticRenderFns } from "./distributeKnowledge.vue?vue&type=template&id=4178774d&scoped=true&"
import script from "./distributeKnowledge.js?vue&type=script&lang=js&"
export * from "./distributeKnowledge.js?vue&type=script&lang=js&"
import style0 from "./distributeKnowledge.css?vue&type=style&index=0&id=4178774d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4178774d",
  null
  
)

export default component.exports